/**
 * Extends Object prototype and adds
 * sParseJSON method which will be used
 * to parse string with try...catch block
 * along with the default value
 */
export default defineNuxtPlugin(() => {
  if (!Object.prototype.sParseJSON) {
    Object.defineProperty(Object.prototype, 'sParseJSON', {
      enumerable: false,
      value: function (defaultJSON = {}, throwError = false) {
        if (!this) {
          return defaultJSON;
        }

        // gives object for string as well
        if (typeof this.valueOf() !== 'string') {
          // eslint-disable-next-line
          console.error(`Trying to parse ${typeof this.valueOf()}, value:`, this);
          return this;
        }
        // else it would be string

        try {
          return JSON.parse(this);
        } catch (err) {
          if (throwError) {
            throw err;
          }
          return defaultJSON;
        }
      }
    });
  }
});
